import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useAlertContext } from "src/components/Alert/AlertContext";
import { alertHandler } from "src/components/Alert/handlers";
import { useNest } from "src/components/Contexts/NestContext";

export function NestPartnerAlert() {
  const { partnerCode } = useNest();
  const { t } = useTranslation();
  const { alerts, setAlerts } = useAlertContext();
  const prevPartnerCodeRef = useRef<string | null>(null);

  useEffect(() => {
    if (partnerCode && partnerCode !== prevPartnerCodeRef.current) {
      alertHandler.createNewAlertEntry({
        fade: true,
        text: t("nest_partner_selected_message", { partner: partnerCode }),
        isSuccess: false,
        variant: "info",
        alerts,
        setAlerts,
      });
    } else if (!partnerCode && prevPartnerCodeRef.current) {
      alertHandler.createNewAlertEntry({
        fade: true,
        text: t("nest_partner_cleared_message"),
        isSuccess: true,
        variant: "success",
        alerts,
        setAlerts,
      });
    }
    prevPartnerCodeRef.current = partnerCode;
  }, [partnerCode]);

  return null;
}
